export default "__VITE_ASSET__BP1qxoAV__"